import React, { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import config from "../../config/config";
var Settings = require("../settings.json");

const SpecialityTopic = () => {
  const [specialityList, setSpecialityList] = useState([]);
  const url = config.BASE_URL + Settings["loadSpecialityUrl"];

  const logInResponse = useSelector((state) => state.loginReducer);
  const userEmail = logInResponse.isLoggedIn ? logInResponse.email : "null";

  useEffect(() => {
    axios
      .get(url, {
        params: {
          email: userEmail,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          setSpecialityList(response.data.response);
        } else {
          throw new Error("Something went wrong ...");
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }, [userEmail, url]);

  return (
    <div className="condition">
      <div className="condition-cards">
        {specialityList.map((spc, i) => {
          return (
            <div className="condition-card" key={"condition-card" + i}>
              <div className="condition-card-header">
                <p className="condition-card-heading">
                  {spc.speciality.speciality}
                </p>
              </div>
              <div className="condition-card-body">
                {spc.topics.map((tp, j) => {
                  return (
                    <div className="topic-line" key={"condition-card-line" + j}>
                      {/* {tp.topicLocked && <i className="fa fa-unlock topic-locked"></i>} */}
                      <i
                        className={`fa ${
                          tp.topicLocked
                            ? "fa-lock topic-locked"
                            : "fa-unlock topic-unlocked"
                        }`}
                      ></i>
                      <Link
                        className="condition-card-line"
                        to={`/topic/${spc.speciality.speciality.replace(
                          /[^a-zA-Z0-9]/g,
                          "-"
                        )}/${tp.id}`}
                      >
                        {tp.title}
                      </Link>
                    </div>
                  );
                })}
              </div>
              <Link
                className="condition-card-dots"
                to={{
                  pathname: "specialty/" + spc.speciality.id,
                  state: spc.speciality.speciality,
                }}
              >
                ...
              </Link>
            </div>
          );
        })}
      </div>
    </div>
  );
};
export default SpecialityTopic;
